import type { OfficeHost } from "@common/types/agent-chat-request";

export function readOfficeHost(): OfficeHost {
    return {
        platform: String(Office.context.diagnostics.platform),
        version: Office.context.diagnostics.version,
    };
}

export function readOfficeHostPlatformOrUnknown(): string {
    try {
        return readOfficeHost().platform;
    } catch {
        return "unknown";
    }
}
